var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductDescription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3883",
    "data-name": "Rectangle 3883",
    width: 20.401,
    height: 20.4,
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13240",
    "data-name": "Group 13240",
    transform: "translate(0 0.082)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3884",
    "data-name": "Rectangle 3884",
    width: 24,
    height: 24,
    transform: "translate(0 -0.082)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13241",
    "data-name": "Group 13241",
    transform: "translate(2 1.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13240-2",
    "data-name": "Group 13240",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_42367",
    "data-name": "Path 42367",
    d: "M16.678,3.322c-.017.045-.036.089-.052.134a1.031,1.031,0,0,1-.986.712q-7.3,0-14.6,0A1.03,1.03,0,0,1,0,3.134q0-1.05,0-2.1A1.029,1.029,0,0,1,1.037,0q7.3,0,14.6,0a1.03,1.03,0,0,1,.986.712c.015.045.034.089.052.134ZM8.339.7H1.157C.81.7.7.809.7,1.156c0,.385,0,.771,0,1.156,0,.261,0,.521,0,.782a.343.343,0,0,0,.375.377c.049,0,.1,0,.147,0H15.456c.06,0,.12,0,.179,0a.325.325,0,0,0,.34-.342q.011-1.042,0-2.084A.325.325,0,0,0,15.635.7c-.059,0-.119,0-.179,0H8.339",
    transform: "translate(1.861 1.861)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42368",
    "data-name": "Path 42368",
    d: "M291.637,146.007c-.034.118-.064.238-.1.355a2.091,2.091,0,1,1,.07-1.013.348.348,0,0,0,.031.072Zm-2.06,1.09a1.384,1.384,0,1,0-1.408-1.36,1.38,1.38,0,0,0,1.408,1.36",
    transform: "translate(-273.098 -135.514)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42369",
    "data-name": "Path 42369",
    d: "M289.25,291.594l-.262-.071a2.087,2.087,0,1,1,2.609-2.378.35.35,0,0,0,.031.072v.586a.632.632,0,0,0-.033.088,2.076,2.076,0,0,1-1.466,1.622c-.1.032-.195.055-.292.081Zm1.677-2.062a1.384,1.384,0,1,0-1.406,1.361,1.38,1.38,0,0,0,1.406-1.361",
    transform: "translate(-273.089 -273.057)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42370",
    "data-name": "Path 42370",
    d: "M5.592,159.533H10.72c.265,0,.424.126.431.339a.349.349,0,0,1-.321.364,1.315,1.315,0,0,1-.163,0H.524a.944.944,0,0,1-.225-.018.346.346,0,0,1,0-.672.9.9,0,0,1,.21-.016h5.08",
    transform: "translate(1.827 -150.729)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42371",
    "data-name": "Path 42371",
    d: "M5.584,208.128H.455c-.256,0-.412-.124-.424-.33a.351.351,0,0,1,.328-.375,1.489,1.489,0,0,1,.163,0H10.713c.273,0,.433.133.433.354s-.161.353-.434.353H5.584",
    transform: "translate(1.832 -196.532)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42372",
    "data-name": "Path 42372",
    d: "M5.592,303.234h5.08a1.006,1.006,0,0,1,.194.01.344.344,0,0,1,.283.331.341.341,0,0,1-.276.353.894.894,0,0,1-.194.013H.5a1.2,1.2,0,0,1-.146,0,.352.352,0,0,1,.008-.7,1.606,1.606,0,0,1,.163,0H5.592",
    transform: "translate(1.829 -288.177)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42373",
    "data-name": "Path 42373",
    d: "M5.608,351.866q-2.54,0-5.08,0a.8.8,0,0,1-.24-.027.317.317,0,0,1-.235-.332.314.314,0,0,1,.231-.318.864.864,0,0,1,.256-.028H10.684c.318,0,.483.12.484.352s-.164.356-.48.356H5.608",
    transform: "translate(1.81 -334.017)",
    fill: "#495584",
    stroke: "#495584",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductDescription);
export default __webpack_public_path__ + "static/media/product-description.a8d37183.svg";
export { ForwardRef as ReactComponent };